export function isPinAuthenticated(data, submittedPin) {
  if (data && data.authenticated === true) return true;

  // Compatibilité de déploiement avec l'ancienne API. À retirer lorsque le
  // serveur sécurisé est effectivement en production.
  const legacyPin = data && data.results && data.results[0] && data.results[0].pin_code;
  return legacyPin !== undefined && String(legacyPin) === String(submittedPin);
}
